import { FCT } from '@/i18n/locales.constant';

export const IssueType = {
  REPORT_ISSUE: FCT.REPORTING.REPORT_ISSUE.ACTIONS.I_M_BLOCKED,
  SUGGEST_IMPROVEMENT: FCT.REPORTING.REPORT_ISSUE.ACTIONS.SUGGEST_IMPROVEMENT,
} as const;

export type IssueTypeValues = (typeof IssueType)[keyof typeof IssueType];

export enum AboutType {
  PATIENT_HISTORY = 'Patient history, priors, and reason for scan',
  ORGANS = 'Organs, findings, and outputs',
  KEY_IMAGES = 'Key images (KI)',
  FINAL_IMPRESSIONS = 'Final impressions',
  REPORT_PREVIEW = 'Report preview and signature',
  SECURITY = 'Security and privacy',
  GENERAL_SYSTEM_USABILITY = 'General system usability',
  OTHER = 'Other',
}

export type CommonStyles = {
  input: string;
  select: {
    content: string;
    trigger: string;
  };
};

export type IssueTypeOption = {
  value: IssueTypeValues;
};

export type AboutTypeOption = {
  value: AboutType;
};

export type DescriptionGuide = {
  items: string[];
  title: string;
};

export type DescriptionGuides = {
  [key: string]: DescriptionGuide;
};

export interface ReportIssueHandlerState {
  aboutType?: AboutType;
  attachedFiles: File[];
  description: string;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: () => void;
  isReportIssueError: boolean;
  isReportIssuePending: boolean;
  isReportIssueSuccess: boolean;
  isReportServiceDeskIssueError: boolean;
  isReportServiceDeskIssuePending: boolean;
  isReportServiceDeskIssueSuccess: boolean;
  issueType?: IssueTypeValues;
  removeFile: (index: number) => void;
  resetForm: () => void;
  resetReportIssue: () => void;
  resetReportServiceDeskIssue: () => void;
  setAboutType: (value?: AboutType) => void;
  setDescription: (value: string) => void;
  setIssueType: (value?: IssueTypeValues) => void;
  setShowErrors: (value: boolean) => void;
  setTitle: (value: string) => void;
  showErrors: boolean;
  title: string;
}
